import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getPackages = async (userType) => {
    const defaultResult = {packages: [], discounts: []}
    if (userType) {
      try {
        const {body} = await Api.post('/package/listByUserType', {userType})
        return body.error ? {error: body.error} : {packages: body.packages, discounts: body.packagePrice}
      } catch (e) {
        return defaultResult
      }
    }
    return defaultResult
  }

  getPackageCategories = async packageId => {
    const defaultResult = {packageCategories: []}
    try {
      const {body} = await Api.post('/packagecategory/getByPackage', {package: packageId})
      return body.error ? defaultResult : {packageCategories: body.results}
    } catch (e) {
      return defaultResult
    }
  }
}
